import { createSelector } from 'reselect';
import { AppState } from '../store';
import { ScheduleBookingAsHealerAction } from '../reducers/schedule-booking-as-healer.reducer';
import { SessionType } from '../../infra/adapters/luminara/session-type/dto/session-type.dto';

export type ScheduleBookingAsHealerPresentation = {
  bookingCreated: boolean;
  invitationLink?: string;
  hasErrors: boolean;
  sessionTypes?: SessionType[];
};

export const selectScheduleBookingAsHealerPresentation = createSelector([(state: AppState) => state.scheduleBookingAsHealer], (scheduleBookingAsHealer) => {
  return {
    bookingCreated: scheduleBookingAsHealer.booking !== undefined,
    invitationLink:
      scheduleBookingAsHealer.booking !== undefined ? window.location.origin + '/dashboard/' + scheduleBookingAsHealer.clientUserProfileId : undefined,
    hasErrors: scheduleBookingAsHealer.loadingDataErrors.length > 0,
    sessionTypes: scheduleBookingAsHealer.sessionTypes,
  } as ScheduleBookingAsHealerPresentation;
});

export const resetHealerBookingInvitationLink = () => ({ type: 'CLEAR_BOOKING' } as ScheduleBookingAsHealerAction);
export const sessionTypesLoadFailed = (err: any) => ({ type: 'SESSION_TYPES_LOAD_FAILED', payload: err } as ScheduleBookingAsHealerAction);
export const sessionTypesLoadedSuccessfully = (sessionTypes: SessionType[]) =>
  ({ type: 'SESSION_TYPES_LOADED', payload: sessionTypes } as ScheduleBookingAsHealerAction);
